import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
    <p className={`font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-teal ${className}`}>
        {children}
    </p>
);
